
/**
 * @class @name Layout
 * @description Exposes menu store module
 */
export default class Layout {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {
            footer: { links: true },
			header: { links: true }
		};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {
			/**
			 * @name setFooter
			 * @param {Object} state
			 */
			setFooter(state, obj) {
                let footer = state.footer;
				state.footer = { footer, ...obj };
			},

            /**
			 * @name setHeader
			 * @param {Object} state
			 */
			setHeader(state, obj) {
                let header = state.header;
				state.header = { header, ...obj };
			}
		};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name setFooter
			 * @param {function} commit
			 */
			setFooter({ commit }, obj) {
				commit('setFooter', obj);
			},

            /**
			 * @async @name setHeader
			 * @param {function} commit
			 */
			setHeader({ commit }, obj) {
				commit('setHeader', obj);
			}
		};
	}
}
